import React, { forwardRef } from 'react'
import { useSelector } from 'react-redux'
import PageHeaderSkeleton from './PageHeaderSkeleton'

const PageHeaderEvent = forwardRef((props, ref) => {
    const event = useSelector(state => state.event)
    const questionnaireName = useSelector(state => state.questionnaire.name)

    return <PageHeaderSkeleton
        ref={ref}
        title={questionnaireName}
        subtitle={event.name}
    />
})

export default PageHeaderEvent
